import {Component, EventEmitter, inject, input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {StorageService} from "@core/services/storage.service";
import {InitialsPipe} from "@shared/pipes/initials.pipe";
import {AppShowWhenHasProfileDirective} from "@shared/directives/show-when-has-permission.directive";

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive, TranslateModule, InitialsPipe, AppShowWhenHasProfileDirective],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
    host: {
        'class': 'sidebar'
    }
})
export class SidebarComponent {

    private storageService = inject(StorageService);
    protected fullName = `${this.storageService.firstName} ${this.storageService.lastName}`;
    protected profile = this.storageService.profile;


    collapsed = input<boolean>(false);
    @Output() closeSidebar = new EventEmitter<void>();

    onNavItemClick() {
        // Fecha o sidebar em mobile quando clicar em um item
        if (window.innerWidth <= 768) {
            this.closeSidebar.emit();
        }
    }

    protected logout() {
        this.storageService.reset();
    }
}

